<!--
 * @Author:  v-maijiahua@oppo.com
 * @Date: 2023-06-30 11:33:05
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-10-16 14:21:26
 * @FilePath: \sns-user-frontend\src\components\themeTag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="theme-tag">
    {{props.text}}
  </div>
</template>

<script setup>
  const props = defineProps({
    text: {
      type: String
    }
  })
</script>

<style lang="postcss" scoped>
.theme-tag {
  flex-shrink: 0;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 3px;
  padding: 0 3px;
  font-size: 12px;
  font-family: "orbit-R";
  height: 16px;
  color: var(--theme);
  background-color: var(--theme-background);
}

@media screen and (max-width: 1023px) {
  .theme-tag {
    color: var(--theme);
    height: 28px;
    font-size: 20px;
    height: auto;
    zoom: .5;
    padding: 0 6px;
  }
}
</style>